import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  obterComprovanteCadastro, obterComprovanteCadastroIdPositiva,
} from '../../api/pdfAPI';

import { RootState } from '../../app/store';

export interface ComprovanteState {
  isFamiliaCadastrada: boolean,
  pdf: any,
  mensagemAtivada: boolean,
  qrCode: any,
  numeroFamiliar: number,
	representanteLegal: any,
	municipioUF: string,
	dataCadastro: any,
  dataAtualizacao: any,
  dataLimiteParaProximaAtualizacao: any,
	cadastroAtualizado: string,
	faixaRendaFamiliarTotal: string,
	faixaRendaFamiliarPorPessoa: string,
	validacaoComprovante: any,
	urlValidacaoComprovante: string
  integrantes: any,
  chaveSeguranca: string,
  dataEmissao: any,
  endereco: string,
  ehIndigena: false,
  ehQuilombola: false,
  nomePovoIndigena: string,
  terraOuReservaIndigena: string,
  comunidadeQuilombola: string
}

const initialState: ComprovanteState = {
  isFamiliaCadastrada: true,
  pdf: null,
  mensagemAtivada: false,
  qrCode: '',
  numeroFamiliar: 0,
	representanteLegal: {},
	municipioUF: '',
	dataCadastro: null,
  dataAtualizacao: null,
  dataLimiteParaProximaAtualizacao: null,
	cadastroAtualizado: '',
	faixaRendaFamiliarTotal: '',
	faixaRendaFamiliarPorPessoa: '',
	validacaoComprovante: {},
	urlValidacaoComprovante: '',
  integrantes: {},
  chaveSeguranca: '',
  dataEmissao: null,
  endereco: '',
  ehIndigena: false,
  ehQuilombola: false,
  nomePovoIndigena: '',
  terraOuReservaIndigena: '',
  comunidadeQuilombola: ''
};

export const getComprovanteCadastro = createAsyncThunk(
  'comprovante/getComprovanteCadastro',
  async (dados: any) => {
    return await obterComprovanteCadastro(dados);
  }
);
export const getComprovanteCadastroRL = createAsyncThunk(
  'comprovante/getComprovanteCadastroRL',
  async (dados: any) => {
    return await obterComprovanteCadastro(dados, true);
  }
);
export const getComprovanteCadastroIdPositiva = createAsyncThunk(
  'comprovante/getComprovanteCadastroIdPositiva',
  async (dados: any) => {
    return await obterComprovanteCadastroIdPositiva(dados.numeroFamiliar, dados.identificador);
  }
);
export const getComprovanteCadastroIdPositivaRL = createAsyncThunk(
  'comprovante/getComprovanteCadastroIdPositivaRL',
  async (dados: any) => {
    return await obterComprovanteCadastroIdPositiva(dados.numeroFamiliar, dados.identificador, true);
  }
);

export const fillFields = (state, action) => {
  state.isFamiliaCadastrada = action.payload.familiaCadastrada;
  state.pdf = action.payload.base64PDF;
  state.qrCode = action.payload.base64QRCode;
  state.numeroFamiliar =  action.payload.numeroFamiliar;
	state.representanteLegal = action.payload.representanteLegal;
	state.municipioUF = action.payload.municipioUF;
	state.dataCadastro = action.payload.dataCadastro;
  state.dataAtualizacao = action.payload.dataAtualizacao;
  state.dataLimiteParaProximaAtualizacao = action.payload.dataLimiteParaProximaAtualizacao;
	state.cadastroAtualizado = action.payload.cadastroAtualizado;
	state.faixaRendaFamiliarTotal = action.payload.faixaRendaFamiliarTotal;
  state.faixaRendaFamiliarPorPessoa = action.payload.faixaRendaFamiliarPorPessoa;
	state.validacaoComprovante = action.payload.validacaoComprovante;
	state.urlValidacaoComprovante = action.payload.urlValidacaoComprovante;
  state.integrantes = action.payload.integrantes;
  state.chaveSeguranca = action.payload.chaveSeguranca;
  state.dataEmissao = action.payload.dataEmissao;
  state.endereco = action.payload.endereco;
  state.ehIndigena = action.payload.ehIndigena;
  state.ehQuilombola = action.payload.ehQuilombola;
  state.nomePovoIndigena = action.payload.nomePovoIndigena;
  state.terraOuReservaIndigena = action.payload.terraOuReservaIndigena;
  state.comunidadeQuilombola = action.payload.comunidadeQuilombola;
}

export const comprovanteSlice = createSlice({
  name: 'comprovante',
  initialState,
  reducers: {
    ativarMensagem: (state, action) => {
      state.mensagemAtivada = action.payload;
    },
    reset: state => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getComprovanteCadastro.fulfilled, (state, action) => {
        fillFields(state, action)
      })
      .addCase(getComprovanteCadastroRL.fulfilled, (state, action) => {
        fillFields(state, action)
      })
      .addCase(getComprovanteCadastroIdPositiva.fulfilled, (state, action) => {
        fillFields(state, action)
      })
      .addCase(getComprovanteCadastroIdPositivaRL.fulfilled, (state, action) => {
        fillFields(state, action)
      });
  },
});

export const {
  ativarMensagem,
  reset
} = comprovanteSlice.actions;

export const selectPdf = (state: RootState) => state.comprovante.pdf;
export const selectFamiliaCadastrada = (state: RootState) => state.comprovante.isFamiliaCadastrada;
export const selectMensagemAtivada = (state: RootState) => state.comprovante.mensagemAtivada;
export const selectComprovante = (state: RootState) => state.comprovante;

export default comprovanteSlice.reducer;

